import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAutomationExecutionEntity } from './outreach-automation-execution.entity';
import { OutreachAutomationStepEntity } from './outreach-automation-step.entity';
import { OutreachSendEntity } from './outreach-send.entity';

@Entity('_outreach_automation_step_execution')
export class OutreachAutomationStepExecutionEntity extends BaseEntity {
	@Column('enum', {
		name: '_execution_status',
		enum: ['pending', 'processing', 'completed', 'failed', 'skipped'],
	})
	public executionStatus!:
		| 'pending'
		| 'processing'
		| 'completed'
		| 'failed'
		| 'skipped';

	@Column('timestamp', { name: '_started_at', nullable: true })
	public startedAt!: Date | null;

	@Column('timestamp', { name: '_completed_at', nullable: true })
	public completedAt!: Date | null;

	@Column('timestamp', { name: '_scheduled_for', nullable: true })
	public scheduledFor!: Date | null;

	@Column('json', { name: '_execution_data', nullable: true })
	public executionData!: object | null;

	@Column('json', { name: '_result_data', nullable: true })
	public resultData!: object | null;

	@Column('text', { name: '_error_message', nullable: true })
	public errorMessage!: string | null;

	@Column('int', { name: '_retry_count', default: () => "'0'" })
	public retryCount!: number;

	@ManyToOne(
		() => OutreachAutomationExecutionEntity,
		(outreachAutomationExecution) =>
			outreachAutomationExecution.outreachAutomationStepExecutions,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{
			name: '_fk__outreach_automation_execution__id',
			referencedColumnName: 'id',
		},
	])
	public fkOutreachAutomationExecution!: OutreachAutomationExecutionEntity;

	@ManyToOne(
		() => OutreachAutomationStepEntity,
		(outreachAutomationStep) =>
			outreachAutomationStep.outreachAutomationStepExecutions,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_automation_step__id', referencedColumnName: 'id' },
	])
	public fkOutreachAutomationStep!: OutreachAutomationStepEntity;

	@OneToMany(
		() => OutreachSendEntity,
		(outreachSend) => outreachSend.fkOutreachAutomationStepExecution,
		{},
	)
	public outreachSends!: Array<OutreachSendEntity>;
}
